// Add your JS customizations here

window.onload = function () {
    require("./slick.js");
}